import MatchedMap from 'utilities/src/matchedMap';

import { ThemeEnum, useTheme } from '../../../Theme';

import type { ButtonThemeProps } from '../types/_theme';

/**
 * Import Themes
 */

import buttonCommonTheme from './_common';

import buttonBlogTheme, { type ButtonBlogThemeArgs } from './blog';
import buttonSiteTheme, { type ButtonSiteThemeArgs } from './site';

/**
 * Group Themes
 */

const buttonThemes = ({ variant = 'Primary', variantColor, bg, size }: ButtonThemeProps) =>
  new MatchedMap([
    [ThemeEnum.Blog, buttonBlogTheme({ variant, size } as ButtonBlogThemeArgs)],
    [ThemeEnum.Site, buttonSiteTheme({ variant, variantColor, bg, size } as ButtonSiteThemeArgs)],
  ]);

/**
 * Theme Hook
 */

const useButtonTheme = (buttonThemeProps: ButtonThemeProps) =>
  useTheme(buttonCommonTheme, buttonThemes(buttonThemeProps));

export default useButtonTheme;
